import { render, staticRenderFns } from "./NotificationContent.vue?vue&type=template&id=ab89df50"
import script from "./NotificationContent.vue?vue&type=script&lang=js"
export * from "./NotificationContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports